<!-- 添加单元 -->
<template>
<div class='addWard'>
  <div class="header df-between" :style="{'padding-top':utils.isIphoneX()?'50px':'30px'}">
    <img src="../../assets/images/i-arrow-left.png" alt="" @click='handleBack' >
    <div class="title">添加单元</div>
    <span></span>
  </div>
  <div class="container">
    <div class="form">
      <!-- 输入任意文本 -->
      <van-field required input-align="right" v-model="unitName" label="单元名称" placeholder="请填写督导的最小组织单元"/>
      <!-- 允许输入正整数，调起纯数字键盘 -->
      <van-field input-align="right" v-model="sortNumber" type="digit" label="自定义排序号" placeholder="用于排序，例：1" />
      <van-field required input-align="right" @click='handleShowDistrict' readonly v-model="branchName" label="所属院区" right-icon="arrow" placeholder="请选择" />
      <van-field required input-align="right" @click='handleShowDeptType' readonly v-model="unitTypeName" label="单元类型" right-icon="arrow" placeholder="请选择" />
      <van-field required input-align="right" @click='handleShowClinicDeptType' readonly v-model="standardName" label="临床科室分类" right-icon="arrow" placeholder="请选择" />
    </div>
    <div class="form-width" style='margin-top:10px;'>
      <van-field required input-align="right" v-model="parentName" label="快速搜索标签分类" placeholder=""/>
    </div>
    <div class="button-box">
      <div class="btn df-center back" @click='handleConfirmAddDept(1)'>保存并返回</div>
      <div class="btn df-center continue" @click='handleConfirmAddDept(2)'>保存并继续添加单元</div>
    </div>
    <van-popup v-model="isShowDistrictPopup" style='border-radius:10px'>
       <div class="district-box">
         <div class="title">
           选择分院
         </div>
         <div class="district-content-box">
          <div class="district-content df-item-center" @click='conFirmDistrict(item)' v-for='(item,index) in deptData' :key='index'>
            {{item.name}}
          </div>
         </div>
         <div class="district-btn df-center" @click='handleCloseDistrictPopup'>取消</div>

       </div>
    </van-popup>
    <yd-popup v-model="isShowDeptSelect" position="right" width="80%" >
      <div class="deptType-box" :style="{'padding-top':deptTypeTitleHeight}">
        <div class="title df-item-center" id='deptTypeTitle' :style="{'padding':utils.isIphoneX()?'50px 15px 15px':'30px 15px 15px'}">单元类型</div>
        <div class="deptType-content df-item-center" @click='conFirmDeptType(item)' v-for='(item,index) in inpatientAreaTypeData' :key='index'>{{item.name}}</div>
      </div>
    </yd-popup>
    <yd-popup v-model="isShowClinicDeptType" position="right" width="100%" >
      <clinicDeptType  v-on:closeClinicDeptType='closeClinicDeptType' v-on:conFirmClinicDeptType='conFirmClinicDeptType' :clinicDeptTypeData='clinicDeptTypeData' v-on:successAddStandardOrTmpDept='successAddStandardOrTmpDept' :quickTagData='quickTagData'></clinicDeptType>
    </yd-popup>

  </div>
</div>
</template>

<script>
import clinicDeptType from './clinicDeptType.vue'
import {mapState} from 'vuex'
export default {
props:['isShowAddWardPage','secondNodeName','deptData'],
data() {
return {
  deptTypeTitleHeight:'',
  quickTagData:[],
  inpatientAreaTypeData:[],
  clinicDeptTypeData:[ ],
  deptId:'',
  unitName: '',
  sortNumber: '',
  branchName: '',
  unitType:'',
  unitTypeName:'',
  standardName:'',
  standardOrderNo:'',
  templateType:'',
  standardCode:'',
  parentName:'',
  parentCode:'',
  parentOrderNo:'',
  isShowDistrictPopup:false,
  isShowDeptSelect:false,
  isShowClinicDeptType:false
};
},
components: {
  clinicDeptType
},
computed: {
  ...mapState({
    _userInfo: (state) => state.InvestorInfo,
  })
},
created() {
},
mounted(){
  this.deptTypeTitleHeight = document.getElementById('deptTypeTitle').offsetHeight + 'px'
},
watch:{
  isShowAddWardPage(){
    if(this.isShowAddWardPage){
      this.queryInpatientAreaType()
      this.querySecondDeptByParam()
      this.queryQuickAndFirstDeptByParam()
    }
  },
  secondNodeName(){
    this.branchName = this.secondNodeName
  }
},
methods: {
  queryInpatientAreaType(){
    let params = {
      comId: this._userInfo.data.comId,
      userId: this._userInfo.data.userId,
      data: {
        comId: this._userInfo.data.comId
      }
    };
    this.$http.queryInpatientAreaType(params).then((res) => {
      if (res.code === 0) {
        console.log(res,'res1');
        this.inpatientAreaTypeData = res.data
      } else {
        this.$toast(res.msg);
      }
    });
  },
  querySecondDeptByParam(){
    let params = {
      comId: this._userInfo.data.comId,
      userId: this._userInfo.data.userId,
      data: {
        comId: this._userInfo.data.comId,
        secondNodeId: localStorage.getItem('secondNodeId')
      }
    };
    this.$http.querySecondDeptByParam(params).then((res) => {
      if (res.code === 0) {
        console.log(res,'res2');
      } else {
        this.$toast(res.msg);
      }
    });
  },
  queryQuickAndFirstDeptByParam(){
    let params = {
      comId: this._userInfo.data.comId,
      userId: this._userInfo.data.userId,
      data: {
        comId: this._userInfo.data.comId,
        secondNodeId: localStorage.getItem('secondNodeId')
      }
    };
    this.$http.queryQuickAndFirstDeptByParam(params).then((res) => {
      if (res.code === 0) {
        this.quickTagData = [...res.data.notRelatedList,...res.data.templateList]
      } else {
        this.$toast(res.msg);
      }
    });
  },
  queryStandardAndNotRelatedIAByParam(){
    let params = {
      comId: this._userInfo.data.comId,
      userId: this._userInfo.data.userId,
      data: {
        comId: this._userInfo.data.comId,
        secondNodeId: localStorage.getItem('secondNodeId')
      }
    };
    this.$http.queryStandardAndNotRelatedIAByParam(params).then((res) => {
      if (res.code === 0) {
        this.clinicDeptTypeData = res.data
        console.log(res,'res4');
      } else {
        this.$toast(res.msg);
      }
    });
  },
  // 保存并添加单元
  handleConfirmAddDept(temp){
    if(this.unitName&&this.branchName&&this.unitTypeName&&this.standardName&&this.parentName){
      this.handleAddOrUpdateForTmpAndDept()
      if(temp==1){
        this.$emit('handlleCloseAddWard')
      }
    }else{
      this.$toast('请先完善必填项信息')
    }
  },
  // 清空填写的数据
  handleReset(){
    this.unitName = ''
    // this.sortNumber = ''
    // this.branchName = ''
    // this.unitTypeName = ''
    // this.standardName = ''
    // this.parentName = ''
  },
  handleAddOrUpdateForTmpAndDept(){
    let params = {
      comId: this._userInfo.data.comId,
      userId: this._userInfo.data.userId,
      data: {
        branchId: localStorage.getItem('secondNodeId'),
        branchName: this.branchName,
        comId: this._userInfo.data.comId,
        deptId: this.deptId,
        operUser: this._userInfo.data.userId,
        orderNo: this.sortNumber,
        quickCode: this.parentCode,
        quickName: this.parentName,
        quickOrderNo: this.parentOrderNo,
        standardCode: this.standardCode,
        standardDeptName: "",
        standardName: this.standardName,
        standardOrderNo: this.standardOrderNo,
        templateType: this.templateType, // 1以平台模板为类型   2以医院自定义模板为类型
        unitName: this.unitName,
        unitType: this.unitType,
        unitTypeName: this.unitTypeName
      }
    };
    this.$http.addOrUpdateForTmpAndDept(params).then((res) => {
      if (res.code === 0) {
        this.handleReset()
        this.$toast(res.msg);
        this.$emit('successAddDept')
      } else {
        this.$toast(res.msg);
      }
    });

  },
  // 显示院区弹窗
  handleShowDistrict(){
    this.isShowDistrictPopup = true
  },
  // 关闭院区弹窗
  handleCloseDistrictPopup(){
    this.isShowDistrictPopup = false
  },
  // 确认院区
  conFirmDistrict(val){
    this.deptId = ''
    this.standardName = ''
    this.standardOrderNo = ''
    this.templateType = ''
    this.standardCode = ''
    this.parentName = ''
    this.parentCode = ''
    this.parentOrderNo = ''
    console.log(val,'val');
    this.branchName = val.name
    this.secondNodeId = val.id
    localStorage.setItem('secondNodeId',val.id)
    this.queryQuickAndFirstDeptByParam()
    this.queryStandardAndNotRelatedIAByParam()
    this.isShowDistrictPopup = false
  },

  // 显示单元类型
  handleShowDeptType(){
    this.isShowDeptSelect = true
  },
  // 确认单元
  conFirmDeptType(val){
    this.unitType = val.code
    this.unitTypeName = val.name
    this.isShowDeptSelect = false
  },

  // 显示临床科室分类
  handleShowClinicDeptType(){
    this.queryQuickAndFirstDeptByParam()
    this.queryStandardAndNotRelatedIAByParam()
    this.isShowClinicDeptType = true
  },
  // 关闭临床科室分类
  closeClinicDeptType(){
    this.isShowClinicDeptType = false
  },
  // 确认临床科室分类
  conFirmClinicDeptType(val){
    this.templateType = val.templateType
    this.deptId = val.id
    this.standardName = val.name
    this.standardOrderNo = val.orderNo
    this.standardCode = val.code
    this.parentName = val.parentName
    this.parentCode = val.parentCode
    this.parentOrderNo = val.parentOrderNo
    this.isShowClinicDeptType = false
    console.log(val,'临床科室分类数据');

  },
  // 添加自定义临床科室分类成功
  successAddStandardOrTmpDept(){
    this.queryStandardAndNotRelatedIAByParam()
  },
  handleBack(){
    this.$emit('handlleCloseAddWard')
  }

},
}
</script>
<style lang='scss' scoped>
  .form-width{
    /deep/ .van-field__label{
      width: 120px;
    }
  }
  .addWard {
    height: 100vh;
    background-color: #f2f2f2;
    .header {
      padding: 15px 15px 15px 5px;
      background-color: #fff;
      color: #000;
      img {
        width: 22px;
        height: 22px;
      }
      .title {
        font-size: 17px;
      }
    }
    .container{
      margin-top: 5px;
      .button-box{
        .btn{
          margin: 0 auto;
          width: 345px;
          height: 44px;
          background: #26b4ff;
          border-radius: 4px;
          font-size: 16px;
          color: #fff;
        }
        .back{
          margin: 40px auto 20px;
        }
      }
      .district-box{
        width: 200px;
        border-radius: 10px;
        font-size: 16px;
        .title{
          height: 35px;
          line-height: 35px;
          padding-left: 15px;
          border-bottom: 1px solid #eee;
          font-family: PingFangSC, PingFangSC-Medium;
          font-size: 17px;
          font-weight: 500;
        }
        .district-content-box{
          min-height: 100px;
          max-height: 180px;
          overflow: scroll;
        }
        .district-content{
          padding-left: 15px;
          height: 40px;
          border-bottom: 1px solid #eee;
        }
        .district-btn{
          height: 35px;
          color: #26b4ff;
        }

      }
      .deptType-box{
        font-size: 16px;
        color: #666;
        .title{
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          background-color: #eee;
          border-bottom: 1px solid #eee;
        }
        .deptType-content{
          height: 40px;
          padding-left: 15px;
          border-bottom: 1px solid #eee;

        }
      }
    }
  }
</style>